import Delegate from "//www.ohmycream.com/cdn/shop/t/168/assets/ftdomdelegate.min.js?v=167457923630348017651677856387";

class TableElement extends HTMLElement {
  connectedCallback() {
      this._getProductTable();
      this._getProductPopup();
  }

  // Get product table
  _getProductTable() {

      let that = this;
      this.productTable = this.querySelector('.shg-table__container');
      if (this.productTable) {

        let handles = this.productTable.getAttribute('data-handles').split(',').join(' OR ');
        let id = this.productTable.getAttribute('data-section-id');
        let variantIDs = this.productTable.getAttribute('data-variant-ids');

        fetch('/search?q=' + handles + '&section_id=shg-products-table&id='+variantIDs)
          .then((response) => response.text())
          .then((html) => {
            let div = document.createElement('div');
            let table = that.querySelector('#shg-table-container-' + id);
            let tableCell = table.querySelectorAll('[data-cell-handle]');
            div.innerHTML = html;

            // Product table cell
            tableCell.forEach(function (cell) {
              let handle = cell.getAttribute('data-cell-handle');
              if (handle === '@0') {
                cell.classList.add('empty-cell')
              } else {
                if (div.querySelector('[data-cell-handle="' + handle + '"]')) {
                  cell.innerHTML = div.querySelector('[data-cell-handle="' + handle + '"]').innerHTML;
                  cell.querySelector('[data-action="toggle-table-popup"]').setAttribute('aria-controls', 'shg-table-product-popup-' + id)
                  cell.querySelector('[data-action="toggle-table-popup"]').setAttribute('data-overlay', 'shg-table-product-overlay-' + id)
                }
              }
            })

            // Complete popup html with all product table
            let popupContainer = div.querySelector('.shg-table__popup-content');
            table.querySelector('.shg-table__popup-content-container').innerHTML = popupContainer.innerHTML;

            // Pour slicker en mobile
            if (window.matchMedia("(max-width: 767px)").matches) {
              that._initTableSliderMobile(table.querySelector('.shg-table__table-rows'), tableCell, id);
            }

          })
          .catch((error) => {
            // Request failed
            console.error(error);
          });
      }
    };

    // Init table slider
    _initTableSliderMobile(slider, tableCell, id) {
      $(slider).on('init', function () {

        let cellHeightsObject = {};
        tableCell.forEach(function (cell) {
          let cellColNb = cell.getAttribute('data-col');
          let cellHeight = cell.querySelector('.shg-table__product-item-info');
          if (cellHeight) {
            cellHeight = cellHeight.scrollHeight;
          }
          if (cellHeightsObject[cellColNb]) {
            if (cellHeight > cellHeightsObject[cellColNb]) {
              cellHeightsObject[cellColNb] = cellHeight
            }
          } else {
            cellHeightsObject[cellColNb] = cellHeight
          }

        })

        tableCell.forEach(function (cell) {
          let cellColNb = cell.getAttribute('data-col');
          let infoCell = cell.querySelector('.shg-table__product-item-info');
          if (infoCell) {
            infoCell.style.minHeight = cellHeightsObject[cellColNb] + 'px'
            infoCell.style.height = cellHeightsObject[cellColNb] + 'px'
          }
        });

        let clonedSlides = slider.querySelectorAll('.slick-cloned')
        if (clonedSlides.length > 0) {
          clonedSlides.forEach(function(row) {
            row.querySelectorAll('.shg-table__table-cell-container').forEach(function(cell) {
              let cellColNb = cell.getAttribute('data-col');
              let infoCell = cell.querySelector('.shg-table__product-item-info');
              if (infoCell) {
                infoCell.style.minHeight = cellHeightsObject[cellColNb] + 'px'
                infoCell.style.height = cellHeightsObject[cellColNb] + 'px'
              }
            })
          })
        }

        // set mobile arrow position
        if (window.matchMedia('(max-width:767px)').matches) {
          if (tableCell[0]) {
            let nextArrow = slider.closest('.shg-table__table-container').querySelector('.shg-table__slider-next-arrow');
            if (nextArrow) {
              nextArrow.style.top = (tableCell[0].offsetHeight + 30) + 'px'
            }
          }
        }

        // refresh slider
        setTimeout(function () {
          $('.shg-table__table-rows')[0].slick.refresh()
        }, 0)

      });

      $(slider).slick({
        arrows: true,
        nextArrow: "#shg-table__slider-next-arrow-" + id,
        prevArrow: "#shg-table__slider-prev-arrow-" + id,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: "unslick"
          }
        ]
      })
    }

    // Toggle product table popup
    _getProductPopup() {
      let that = this;
      new Delegate(this).on('click', '[data-action="toggle-table-popup"]', function () {
        let handle = this.getAttribute('data-popup-handle');
        let popup = that.querySelector('#' + this.getAttribute('aria-controls'));
        let popupContent = popup.querySelector('[data-popup-content="' + handle + '"]')
        let popupCloseButton = popup.querySelector('.shg-product-item__slider-horizontal-close');
        let overlay = that.querySelector('#' + this.getAttribute('data-overlay'))

        that._toggleElem(popup, overlay);

        popup.querySelectorAll('[data-popup-content]').forEach(function (content) {
          content.classList.remove('active');
        })

        if (popupContent.classList.contains('active')) {
          popupContent.classList.remove('active');

          popupCloseButton.removeAttribute('data-popup-handle');
          overlay.removeAttribute('data-popup-handle')
        } else {
          popupContent.classList.add('active');

          popupCloseButton.setAttribute('data-popup-handle', handle);
          overlay.setAttribute('data-popup-handle', handle)
        }
      })
    };

    _toggleElem(elem, overlay) {
      if (elem) {
        elem.setAttribute('aria-hidden', elem.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
      if (overlay) {
        overlay.setAttribute('aria-hidden', overlay.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    };
}

try {
  window.customElements.define('table-element', TableElement);
} catch(e) {}